import { useController, type Control } from 'react-hook-form';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TemplateNameField } from '@dealstack/frontend/shared/components/FieldBinding/TemplateNameField/TemplateNameField.tsx';
import { MASTER_DOCUMENT_FORM_FIELD, MasterDocumentFormDto } from './types.ts';

interface Props {
	control: Control<MasterDocumentFormDto>;
	disabled?: boolean;
}

/**
 * The master document's name, for the editor modal's side panel.
 *
 * Its own component so the field subscription lives here rather than on the form: rendered in
 * `MasterDocumentForm` the `useController` would re-render every control on the form per
 * keystroke. It edits the form's field rather than saving, so the form's Save remains the only
 * writer and the name on the form and in the editor can never disagree.
 */
export const MasterDocumentNameField = ({ control, disabled }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { field } = useController({ control, name: MASTER_DOCUMENT_FORM_FIELD.name });

	return (
		<TemplateNameField
			value={field.value ?? ''}
			onChange={field.onChange}
			onBlur={field.onBlur}
			label={tMipManage('master_documents.text.document_name')}
			placeholder={tMipManage('master_documents.text.name_placeholder')}
			disabled={disabled ?? false}
		/>
	);
};
